import { BorderRadiusIcon } from './BorderRadiusIcon';

/**
 * author: Sintija
 * id 3BF9D4F8-DD9D-4D5E-A1B4-A1AA22172E47
 * name border-radius
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/border-radius.svg
 * tags
 * - Text / Content / Format 
 */
export const BorderRoundCornersIcon = BorderRadiusIcon;
export default BorderRoundCornersIcon